import { render, staticRenderFns } from "./o-clients-v3.vue?vue&type=template&id=75f58dd5&scoped=true"
import script from "./o-clients-v3.vue?vue&type=script&lang=js"
export * from "./o-clients-v3.vue?vue&type=script&lang=js"
import style0 from "./o-clients-v3.vue?vue&type=style&index=0&id=75f58dd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f58dd5",
  null
  
)

export default component.exports